import { type VariantProps, cva } from 'class-variance-authority';
import type { ElementType, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

export interface ContainerProps
    extends CommonProps,
        VariantProps<typeof ContainerStyles> {
    as?: ElementType;
    children?: ReactNode;
}

export const ContainerStyles = cva(null, {
    variants: {
        maxWidth: {
            none: null,
            xl: 'max-w-container-xl mx-auto px-4',
            lg: 'max-w-container-lg mx-auto px-4',
        },
    },
    defaultVariants: {
        maxWidth: 'xl',
    },
});

export const Container = ({
    maxWidth,
    as: Element = 'div',
    className,
    testId = 'container',
    children,
    ...props
}: ContainerProps): JSX.Element => {
    return (
        <Element
            className={twMerge(ContainerStyles({ maxWidth, className }))}
            data-testid={testId}
            {...props}
        >
            {children}
        </Element>
    );
};
